// ============================================
// FLOWER & MOON — Shopify Theme JavaScript v2
// theme.js — adapted for Shopify Liquid
// ============================================

// --- Shopify Cart Count Update ---
function updateCartCount() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const countEls = document.querySelectorAll('.header-cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
      });
    })
    .catch(() => {});
}

// Run on page load
updateCartCount();

// Expose globally so cart.js can call it after add-to-cart
window.FMUpdateCartCount = updateCartCount;

document.addEventListener('DOMContentLoaded', function () {

  // --- Header scroll shadow ---
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // --- Mobile Menu ---
  const menuToggle = document.getElementById('menu-toggle') || document.querySelector('.header-hamburger');
  const mobileNav  = document.getElementById('mobile-nav') || document.querySelector('.mobile-nav');
  const mobileClose = document.getElementById('menu-close') || document.querySelector('.mobile-nav__close');

  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }

  // --- Active nav link ---
  const currentPath = window.location.pathname;
  document.querySelectorAll('.header-nav a, .mobile-nav a').forEach(link => {
    const href = link.getAttribute('href');
    if (href && href !== '/' && currentPath.includes(href)) {
      link.classList.add('active');
    } else if (href === '/' && currentPath === '/') {
      link.classList.add('active');
    }
  });

  // --- Product Gallery Thumbnails ---
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.querySelector('.product-gallery__main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img').src.replace('w=200', 'w=900');
      if (mainImage) mainImage.src = src;
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Cart quantity buttons are owned entirely by cart.js (AJAX update).
  // The legacy display-only handler that lived here was removed — it
  // double-applied every click (see QA C2).

  // --- Variant select: update price display ---
  const variantSelect = document.querySelector('[data-variant-select]');
  const priceDisplay = document.querySelector('[data-price-display]');
  if (variantSelect && priceDisplay) {
    variantSelect.addEventListener('change', function () {
      const selected = this.options[this.selectedIndex];
      if (selected.dataset.price) {
        // cart.js owns the compare-at price and the "% off" chip; only write to
        // the current-price node so that markup survives.
        const nowEl = priceDisplay.querySelector('[data-price-current]');
        const target = nowEl || priceDisplay;
        target.textContent = formatMoney(parseInt(selected.dataset.price));
      }
    });
  }

  function formatMoney(cents) {
    // Matches Liquid's `money` filter (and cart.js) — cents always shown.
    return '$' + (cents / 100).toFixed(2);
  }

  // --- Next roast / ship date (snippets/fm-roast-date.liquid) ---
  // We roast on Sunday and ship on Monday; orders are cut off Saturday 6pm
  // Pacific. Everything below works on the Pacific *calendar day*, held as a
  // Date whose UTC fields are that day, so adding days never trips over DST.
  var FMRoast = (function () {
    var CUTOFF_HOUR = 18;   // Saturday 6pm, Pacific
    var ZONE = 'America/Los_Angeles';

    // The wall clock in Pacific, whatever zone the shopper's device is in.
    function pacificParts(date) {
      var parts = new Intl.DateTimeFormat('en-CA', {
        timeZone: ZONE,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hour12: false
      }).formatToParts(date).reduce(function (acc, p) {
        acc[p.type] = p.value;
        return acc;
      }, {});
      var hour = parseInt(parts.hour, 10);
      return {
        y: parseInt(parts.year, 10),
        m: parseInt(parts.month, 10),
        d: parseInt(parts.day, 10),
        // some engines report midnight as 24
        h: hour === 24 ? 0 : hour,
        min: parseInt(parts.minute, 10)
      };
    }

    function addDays(day, n) {
      return new Date(day.getTime() + n * 86400000);
    }

    // Is this Monday a US federal holiday? Only Mondays are ever passed in, so
    // e.g. Jan 2 can only be the observed New Year's Day, and Dec 26 the
    // observed Christmas.
    function isMondayHoliday(day) {
      var m = day.getUTCMonth() + 1;
      var d = day.getUTCDate();
      var nth = Math.ceil(d / 7);           // nth Monday of the month

      if (m === 1 && (d === 1 || d === 2)) return true;    // New Year's Day
      if (m === 1 && nth === 3) return true;               // MLK Day
      if (m === 2 && nth === 3) return true;               // Presidents' Day
      if (m === 5 && d + 7 > 31) return true;              // Memorial Day (last Monday)
      if (m === 6 && (d === 19 || d === 20)) return true;  // Juneteenth
      if (m === 7 && (d === 4 || d === 5)) return true;    // Independence Day
      if (m === 9 && nth === 1) return true;               // Labor Day
      if (m === 10 && nth === 2) return true;              // Indigenous Peoples' / Columbus Day
      if (m === 11 && (d === 11 || d === 12)) return true; // Veterans Day
      if (m === 12 && (d === 25 || d === 26)) return true; // Christmas Day
      return false;
    }

    // Returns { roast, ship } as UTC-encoded calendar days.
    function nextDates(now) {
      var p = pacificParts(now || new Date());
      var today = new Date(Date.UTC(p.y, p.m - 1, p.d));
      var dow = today.getUTCDay();          // 0 Sun … 6 Sat

      var roast = addDays(today, (7 - dow) % 7);   // this week's Sunday

      // Saturday evening and all of Sunday are past the cutoff for that roast.
      var missed = dow === 0 || (dow === 6 && p.h * 60 + p.min >= CUTOFF_HOUR * 60);
      if (missed) roast = addDays(roast, 7);

      var ship = addDays(roast, 1);                // Monday
      if (isMondayHoliday(ship)) ship = addDays(ship, 1);

      return { roast: roast, ship: ship };
    }

    function label(day) {
      return new Intl.DateTimeFormat('en-US', {
        timeZone: 'UTC', weekday: 'long', month: 'long', day: 'numeric'
      }).format(day);
    }

    function sentence(now) {
      var d = nextDates(now);
      return 'Roasted ' + label(d.roast) + ' · ships ' + label(d.ship);
    }

    // Wording when the bag also holds pre-order bags, so this is only one of
    // the two shipments.
    function splitSentence(now) {
      var d = nextDates(now);
      return 'In-stock bags roasted ' + label(d.roast) + ' · ship ' + label(d.ship);
    }

    return { nextDates: nextDates, sentence: sentence, splitSentence: splitSentence, label: label };
  })();

  window.FMRoast = FMRoast;

  var roastEl = document.querySelector('[data-roast-date]');
  if (roastEl && window.Intl && Intl.DateTimeFormat) {
    var roastText = roastEl.querySelector('[data-roast-date-text]');
    if (roastText) {
      roastText.textContent = roastEl.hasAttribute('data-roast-split')
        ? FMRoast.splitSentence()
        : FMRoast.sentence();
      roastEl.hidden = false;
    }
  }

  // --- Collection filters (snippets/fm-filters.liquid) ---
  // Values picked within one group widen the results (light OR medium); groups
  // narrow each other (light AND espresso). Filtering is done here rather than
  // by reloading a filtered URL because the whole collection is already on the
  // page — a few dozen cards at most.
  var filterBar = document.querySelector('[data-filters]');
  if (filterBar) {
    var filterCards = Array.prototype.slice.call(
      document.querySelectorAll('.collection-grid .product-card')
    );
    var filterPills = Array.prototype.slice.call(filterBar.querySelectorAll('[data-filter-group]'));
    var filterClear = filterBar.querySelector('[data-filter-clear]');
    var filterCount = filterBar.querySelector('[data-filter-count]');
    var filterEmpty = document.querySelector('[data-filter-empty]');
    var chosen = {};   // group -> array of chosen values

    function cardMatches(card) {
      for (var group in chosen) {
        if (!chosen[group].length) continue;
        // The facet is pipe-delimited ("|espresso|pour over|"), so a bag can
        // hold several values and still match any one of them. The pipes keep
        // "espresso" from matching inside "espresso blend".
        var facet = card.getAttribute('data-facet-' + group) || '';
        var hit = chosen[group].some(function (value) {
          return facet.indexOf('|' + value + '|') !== -1;
        });
        if (!hit) return false;
      }
      return true;
    }

    function applyFilters() {
      var shown = 0;
      filterCards.forEach(function (card) {
        var match = cardMatches(card);
        card.hidden = !match;
        if (match) shown++;
      });

      var any = Object.keys(chosen).some(function (g) { return chosen[g].length; });
      if (filterClear) filterClear.hidden = !any;
      if (filterEmpty) filterEmpty.hidden = shown !== 0;
      if (filterCount) {
        filterCount.textContent = any
          ? 'Showing ' + shown + ' of ' + filterCards.length
          : '';
      }
    }

    filterPills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var group = pill.dataset.filterGroup;
        var value = pill.dataset.filterValue;
        if (!chosen[group]) chosen[group] = [];

        var at = chosen[group].indexOf(value);
        if (at === -1) chosen[group].push(value);
        else chosen[group].splice(at, 1);

        pill.classList.toggle('is-active', at === -1);
        pill.setAttribute('aria-pressed', at === -1 ? 'true' : 'false');
        applyFilters();
      });
    });

    if (filterClear) {
      filterClear.addEventListener('click', function () {
        chosen = {};
        filterPills.forEach(function (p) {
          p.classList.remove('is-active');
          p.setAttribute('aria-pressed', 'false');
        });
        applyFilters();
      });
    }
  }

  // --- Announcement bar close ---
  const announcementClose = document.querySelector('.announcement-bar__close, [data-announcement-close]');
  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      try { sessionStorage.setItem('announcement-closed', '1'); } catch(e) {}
    });
    try {
      if (sessionStorage.getItem('announcement-closed') === '1') {
        announcementBar.style.display = 'none';
      }
    } catch(e) {}
  }

  // --- Announcement bar message rotation ---
  const announcementMsgs = document.querySelectorAll('.announcement-bar__msg');
  if (announcementMsgs.length > 1) {
    let currentMsg = 0;
    setInterval(() => {
      announcementMsgs[currentMsg].classList.remove('active');
      currentMsg = (currentMsg + 1) % announcementMsgs.length;
      announcementMsgs[currentMsg].classList.add('active');
    }, 4000);
  }

  // --- Expandable sections ---
  document.querySelectorAll('.expandable__toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.previousElementSibling;
      if (!content) return;
      const isOpen = content.classList.toggle('open');
      btn.classList.toggle('open', isOpen);
      btn.textContent = isOpen ? 'Show less' : btn.dataset.label || 'Learn more';
    });
  });

  // --- Scroll Reveal Animations ---
  const reveals = document.querySelectorAll('.reveal');
  if (reveals.length > 0 && 'IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -20px 0px'
    });
    reveals.forEach(el => revealObserver.observe(el));
  } else {
    // Fallback: reveal everything immediately
    reveals.forEach(el => el.classList.add('visible'));
  }

  // --- Staggered product card reveals ---
  const productCards = document.querySelectorAll('.product-grid .product-card, .collection-grid .product-card');
  if (productCards.length > 0 && 'IntersectionObserver' in window) {
    const cardObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const card = entry.target;
          const idx = Array.from(productCards).indexOf(card);
          setTimeout(() => {
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          }, idx * 100);
          cardObserver.unobserve(card);
        }
      });
    }, { threshold: 0.08 });
    productCards.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(24px)';
      card.style.transition = 'opacity 0.6s cubic-bezier(0.25, 0, 0.1, 1), transform 0.6s cubic-bezier(0.25, 0, 0.1, 1)';
      cardObserver.observe(card);
    });
  }

  // --- Journal article card staggered reveal ---
  const articleCards = document.querySelectorAll('.journal-teaser__grid .article-card, .journal-grid .article-card');
  if (articleCards.length > 0 && 'IntersectionObserver' in window) {
    const articleObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const card = entry.target;
          const idx = Array.from(articleCards).indexOf(card);
          setTimeout(() => {
            card.style.opacity = '1';
            card.style.transform = 'translateY(0)';
          }, idx * 120);
          articleObserver.unobserve(card);
        }
      });
    }, { threshold: 0.08 });
    articleCards.forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.6s cubic-bezier(0.25, 0, 0.1, 1), transform 0.6s cubic-bezier(0.25, 0, 0.1, 1)';
      articleObserver.observe(card);
    });
  }

  // Product-card flip is hover-only (desktop). The old touch-device tap-to-flip
  // was removed: it toggled a .is-flipped class that has no CSS rule and
  // preventDefault()ed the first tap, so on phones the first tap did nothing
  // and blocked navigation (QA M4). On touch, a tap now just opens the product.

  // --- M3: Scroll reveal — reduce rootMargin on mobile to prevent elements staying hidden ---
  // Already handled above in reveal observer (threshold: 0.08 is fine for mobile)
  // Safety net: after 2s, force-reveal any .reveal elements that are still invisible
  // (handles edge cases where IntersectionObserver fires late on slow mobile)
  setTimeout(function() {
    document.querySelectorAll('.reveal:not(.visible)').forEach(function(el) {
      el.classList.add('visible');
    });
    // Also force product/article card reveals
    document.querySelectorAll(
      '.product-grid .product-card, .collection-grid .product-card, ' +
      '.journal-teaser__grid .article-card, .journal-grid .article-card'
    ).forEach(function(card) {
      if (card.style.opacity === '0') {
        card.style.opacity = '1';
        card.style.transform = 'translateY(0)';
      }
    });
  }, 2000);

});
